import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, useTheme, Card, CircularProgress } from '@mui/material';
import userApi from '../api/user';
import CardScreen from '../components/CardScreen';
import { Restaurant } from '../models/restaurant';
import RestaurantDetailsBottomSheet from '../components/dumb/RestaurantDetailsBottomSheet';
const PublicProfile = () => {
  const { username } = useParams<{ username: string }>();
  const theme = useTheme();
  const [profile, setProfile] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [selectedRestaurant, setSelectedRestaurant] = useState<Restaurant | null>(null);

  useEffect(() => {
    if (!username) return;
    setLoading(true);
    userApi
      .getPublicProfile(username)
      .then(setProfile)
      .finally(() => setLoading(false));
  }, [username]);

  const handleRestaurantClick = (restaurant: Restaurant) => {
    setSelectedRestaurant(restaurant);
  };

  return (
    <CardScreen>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : profile ? (
        <>
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            {profile.profilePictureUrl && (
              <Box
                component="img"
                src={profile.profilePictureUrl}
                sx={{
                  width: 100,
                  height: 100,
                  borderRadius: '50%',
                  objectFit: 'cover',
                  background: theme.palette.grey[100],
                }}
              />
            )}
            <Box>
              <Typography variant="h6">
                {profile.firstName} {profile.lastName}
              </Typography>
              <Typography variant="body2" color={theme.palette.grey[500]}>
                @{profile.handle}
              </Typography>
            </Box>
          </Box>
          <Typography variant="subtitle1" mt={2} mb={1} fontWeight={600}>
            Liked Restaurants
          </Typography>
          <Box>
            {profile.likedRestaurants && profile.likedRestaurants.length > 0 ? (
              profile.likedRestaurants.map((restaurant: Restaurant) => (
                <Card
                  key={restaurant.id}
                  sx={{ px: 2, py: 1, mb: 1, cursor: 'pointer' }}
                  onClick={() => handleRestaurantClick(restaurant)}
                >
                  <Box display="flex" alignItems="center" gap={2}>
                    {restaurant.imageUrl && (
                      <Box
                        component="img"
                        src={restaurant.imageUrl}
                        sx={{ width: 60, height: 60, borderRadius: 2, objectFit: 'cover' }}
                      />
                    )}
                    <Typography fontWeight={500}>{restaurant.title}</Typography>
                  </Box>
                </Card>
              ))
            ) : (
              <Typography color={theme.palette.grey[500]}>No liked restaurants yet.</Typography>
            )}
          </Box>
          <RestaurantDetailsBottomSheet
            isOpen={!!selectedRestaurant}
            onClose={() => setSelectedRestaurant(null)}
            restaurant={selectedRestaurant}
          />
        </>
      ) : (
        <Typography color={theme.palette.error.main}>User not found.</Typography>
      )}
    </CardScreen>
  );
};

export default PublicProfile;
